import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import MusicPage from "./pages/Music";
import SoundtracksPage from "./pages/Soundtracks";
import VideosPage from "./pages/Videos";
import AboutPage from "./pages/About";
import ContactPage from "./pages/Contact";
import PaymentSuccessPage from "./pages/PaymentSuccess";
import ProductDetail from "./pages/ProductDetail";
import CartPage from "./pages/Cart";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <div className="App font-lato">
            <BrowserRouter>
              <Navigation />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/music" element={<MusicPage />} />
                  <Route path="/soundtracks" element={<SoundtracksPage />} />
                  <Route path="/music/:id" element={<ProductDetail />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/videos" element={<VideosPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/payment/success" element={<PaymentSuccessPage />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </main>
              <Footer />
              <Toaster position="top-right" richColors />
            </BrowserRouter>
          </div>
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
